module.exports = __webpack_public_path__ + "img/big_1_44.22e6e36f.png";